import { useMutation } from "@tanstack/react-query";
import { CREATE_REVIEW } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { ApiResponseData } from "api/types";
import { IReturnType } from "hooks/types";
import { SnackbarSeverity } from "hooks/useSnackbar";
import IReview from "models/Reviews";

type Props = {
  callback?: () => void;
  showSnackbar?: (message: string, severity: SnackbarSeverity) => void;
};

const useCreateReviewMutation = ({ callback, showSnackbar }: Props) => {
  const {
    data: response,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
    mutate,
  }: IReturnType<ApiResponseData<IReview>> = useMutation(
    [CREATE_REVIEW],
    (newReview) => {
      return fetchApi(`reviews`).post(`reviews`, newReview);
    },
    {
      onSuccess: (data) => {
        showSnackbar && showSnackbar("Review Created Successfully", "success");
        callback && callback();
      },
      onError: (error) => {
        showSnackbar("Failed to Create New Review", "error");
      },
    }
  );

  return { data: response?.data, isLoading, isError, isFetching, isSuccess, mutate, refetch };
};

export default useCreateReviewMutation;